import styled from '@emotion/styled';
import Star from './Star';

import {
  Description,
  DescriptionWrapper,
  ImageBackground,
  ImageWrapper,
  Statement,
  StoryItemWrapper,
  Title,
} from './StoryItem.styled';

type Props = {};

const StoryItemThird = (props: Props) => {
  return (
    <StoryItemWrapper>
      <ImageWrapper>
        <ImageBackground src='/images/storyImage_3.png' />
        <ImageGummy src='/images/gummy_adult.gif' />
        <Star top={91} left={30} glowStart={200} />
        <Star top={110} left={50} />
        <Star top={120} left={25} glowStart={800} />
        <Star top={81} left={150} glowStart={300} />

        <Star top={88} left={180} />
        <Star top={100} left={200} glowStart={800} />
        <Star top={110} left={120} />
        <Star top={140} left={120} glowStart={700} />
        <Star top={140} left={220} glowStart={100} />

        <Star top={100} left={310} />
        <Star top={130} left={295} glowStart={200} />
        <Star top={220} left={290} glowStart={800} />
      </ImageWrapper>
      <DescriptionWrapper>
        <Title>Is this Utopia?</Title>
        <Description>
          <Statement>
            맛있는 음식도 먹고, 새로운 친구들도 사귀게 되는데..!
          </Statement>
          <Statement>문득 4차원 세계의 친구들이 그리워진다</Statement>
          <Statement>
            ‘친구들을 여기로 데려오고 싶어 어떻게 해야 하지?’
          </Statement>
          <Statement>
            그렇게 친구들을 데려오기 위한 여정이 시작되는데…!
          </Statement>
        </Description>
      </DescriptionWrapper>
    </StoryItemWrapper>
  );
};

const ImageGummy = styled.img`
  position: absolute;
  top: 156px;
  left: 100px;
  width: 139px;
  /* width: fit-content; */
  height: 134px;
  object-fit: contain;
`;

export default StoryItemThird;
